import {
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    IconButton
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { ModalAlertData } from '../../../../redux/slices/mobileAppModalAlertSlice';

interface Props {
    items: ModalAlertData[];
    openDialog?: (item: ModalAlertData) => void;
    onDelete?: (_id: string) => void;
}

const cellStyles = {
    color: 'white'
};

const ModalAlertTable = ({ items, openDialog, onDelete }: Props) => {
    return (
        <TableContainer sx={{ mt: 3 }} component={Paper}>
            <Table>
                <TableHead sx={{ bgcolor: '#2FCB75' }}>
                    <TableRow>
                        <TableCell sx={cellStyles}>Фото</TableCell>
                        <TableCell sx={cellStyles}>Заголовок</TableCell>
                        <TableCell sx={cellStyles}>Опис</TableCell>
                        <TableCell sx={cellStyles}>Екран</TableCell>
                        <TableCell sx={cellStyles}>Статус</TableCell>
                        <TableCell sx={cellStyles}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items?.map?.(item => (
                        <TableRow hover key={item._id}>
                            <TableCell>
                                {item.photo?.startsWith('uploads/') ? (
                                    <img
                                        alt='modal-img'
                                        style={{ maxWidth: 150 }}
                                        src={`${process.env.REACT_APP_API_URL}/public/${item.photo}`}
                                    />
                                ) : (
                                    'Немає фото'
                                )}
                            </TableCell>
                            <TableCell>{item.mainText}</TableCell>
                            <TableCell>{item.description}</TableCell>
                            <TableCell>{item.description2}</TableCell>
                            <TableCell>{item.enabled ? 'Активний' : 'Неактивний'}</TableCell>
                            <TableCell>
                                <IconButton
                                    size='small'
                                    onClick={() => openDialog?.(item)}
                                >
                                    <Edit />
                                </IconButton>
                                {
                                    item?._id ? (
                                        <IconButton
                                            size='small'
                                            onClick={() => onDelete?.(item._id as string)}
                                        >
                                            <Delete />
                                        </IconButton>
                                    ) : null
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ModalAlertTable;
